import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UrlValidationService {

  /**
   * Validates a redirect URL against the whitelist
   * @param redirectUrl The URL to validate
   * @returns An object containing the validation result and the validated URL
   */
  validateRedirectUrl(redirectUrl: string | null): { isValid: boolean, url: string } {
    if (!redirectUrl) {
      return { isValid: false, url: '' };
    }

    try {
      const redirect = new URL(redirectUrl);
      const isWhitelisted = environment.whitelist.includes(redirect.hostname);

      return {
        isValid: isWhitelisted,
        url: isWhitelisted ? redirectUrl : ''
      };
    } catch (e) {
      return { isValid: false, url: '' };
    }
  }
}
